import React from 'react'
import styled from 'styled-components'
import {serviceRequestStatusColor} from '../../../utils/helpers'
import {formatDate} from '../../../utils/time'
import {_L, useLocaleState} from '../../../context/LocaleContext'
import {SERVICE_REQUEST_DETAIL} from '../../../constants/const'
import {useUIDispatch} from '../../../context/UIContext'

const Container = styled.div`
  border-radius: 5px;
  background-color: #ffffff;
  min-height: 100px;
  box-sizing: border-box;
  padding: 10px 18px 20px 18px;
  border-bottom: 1px solid #f3f5fb;
  cursor: pointer;
`

const ServiceId = styled.div`
  font-size: small;
`

const StatusIndicator = styled.div`
  display: inline-block;
  border-radius: 50%;
  width: 8px;
  height: 8px;
  margin-right: 4px;
  background-color: ${props => props.color};
`

const StatusLabel = styled.span`
  font-size: small;
  font-weight: bold;
  color: ${props => props.color};
`

const HeaderContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding-top: 4px;
`

const ScheduleContainer = styled.div`
  font-size: small;
  padding: 10px 0 10px 0;
`
const DescriptionContainer = styled.div`
  border-radius: 5px;
  background-color: #f3f5fb;
  padding: 5px;
  margin-top: 5px;
  min-height: 50px;
  font-size: small;
`
const Status = ({color, status}) => (
  <div>
    <StatusIndicator color={color} />
    <StatusLabel color={color}>{status}</StatusLabel>
  </div>
)

const ServiceRequest = ({parentPage, request}) => {
  const localeState = useLocaleState()
  const uiDispatch = useUIDispatch()
  const {
    activityLogId,
    status,
    statusFormat,
    description,
    dateScheduled,
    dateCompleted,
    dateRequested
  } = request
  const statusText = status === 'IN PROGRESS' ? 'APPROVED' : status
  const color = serviceRequestStatusColor[statusText]

  const generateScheduleText = request => {
    let scheduleText
    let date
    switch (request.status) {
      case 'SCHEDULED':
      case 'IN PROGRESS':
        scheduleText = _L({
          key: 'Your request is scheduled for:',
          localeState
        })
        date = formatDate(dateScheduled, 'L')
        break
      case 'COMPLETED':
      case 'COMPLETED-V':
      case 'CLOSED':
        scheduleText = _L({
          key: 'Your request was completed on:',
          localeState
        })
        date = formatDate(dateCompleted, 'L')
        break
      default:
        scheduleText = _L({
          key: 'Your request was submitted on:',
          localeState
        })
        date = formatDate(dateRequested, 'L')
    }

    return scheduleText + ' ' + date
  }

  const onShowDetails = () => {
    uiDispatch({
      type: 'setContent',
      payload: {
        content: SERVICE_REQUEST_DETAIL,
        props: {activityLogId},
        parentPage: parentPage
      }
    })
  }

  return (
    <Container
      onClick={() => {
        onShowDetails()
      }}
    >
      <HeaderContainer>
        <ServiceId>#{activityLogId}</ServiceId>
        <Status status={statusFormat} color={color} />
      </HeaderContainer>
      <ScheduleContainer>{generateScheduleText(request)}</ScheduleContainer>
      <DescriptionContainer>{description}</DescriptionContainer>
    </Container>
  )
}

export default ServiceRequest
